{
	"continueEditing": "Continue Editing",
	"creatingProject": "Creating project...",
	"existingCatalogMessage": "Do you want to reset this project or continue editing?",
	"existingCatalogTitle": "This project contains a catalog with existing edits",
	"nestedCatalogFoundMessage": "A project already exists in a subfolder ({{path}}). Delete its .catalog file in the subfolder before creating a new project.",
	"nestedCatalogFoundTitle": "Project catalog found in a subfolder",
	"ratingsReset": "Ratings have been reset.",
	"resetProject": "Reset Project"
}
